import React, { useEffect, useRef } from "react";
import LeaderLine from "react-leader-line";
import { useStateIfMounted } from "use-state-if-mounted";
import { useParams } from "react-router-dom";
import "./../../../css/app.css";
import mqtt_topics from "../../../mqtt/mqtt_topics.js";
import useCheckMobileScreen from "./useCheckMobileScreen.jsx";
// Import all images statically
import towerImg from "./../../../images/diagram/fuel_saver/colored/tower.png";
import towerOnImg from "./../../../images/diagram/normal/tower_on.png";
import generatorImg from "./../../../images/diagram/fuel_saver/colored/generator.png";
import onloadImg from "./../../../images/diagram/fuel_saver/colored/onload.png";
import homeImg from "./../../../images/diagram/fuel_saver/colored/home.png";
import onGridInverterImg from "./../../../images/diagram/fuel_saver/colored/ongrid_inverter.png";
import offloadImg from "./../../../images/diagram/fuel_saver/colored/offload.png";
import inverterImg from "./../../../images/diagram/fuel_saver/colored/inverter.png";
import pvImg from "./../../../images/diagram/fuel_saver/colored/pv.png";
import batteryChargingGif from "./../../../images/diagram/fuel_saver/colored/battery_charging.gif";
import batteryAlertImg from "./../../../images/diagram/fuel_saver/colored/battery-alert.png";
import contactorClose from "./../../../images/diagram/normal/cont_close.png";
import contactorOpen from "./../../../images/diagram/normal/cont_open.png";
import loadImg from "./../../../images/diagram/normal/load.png";
import g1OnImg from "./../../../images/diagram/normal/g1_on.png";
import g1offImg from "./../../../images/diagram/normal/g1.png";
// Import battery level images 0-100% individually
import battery0 from "./../../../images/diagram/fuel_saver/colored/battery_0.png";
import battery20 from "./../../../images/diagram/fuel_saver/colored/battery_20.png";
import battery40 from "./../../../images/diagram/fuel_saver/colored/battery_40.png";
import battery60 from "./../../../images/diagram/fuel_saver/colored/battery_60.png";
import battery80 from "./../../../images/diagram/fuel_saver/colored/battery_80.png";
import battery100 from "./../../../images/diagram/fuel_saver/colored/battery_100.png";

// Normal LED Indicators
import red_onIndicator from "./../../../images/diagram/normal/red_onIndicator.png";
import red_offIndicator from "./../../../images/diagram/normal/red_offIndicator.png";
import green_onIndicator from "./../../../images/diagram/normal/green_onIndicator.png";
import green_offIndicator from "./../../../images/diagram/normal/green_offIndicator.png";
import loadingImg from "./../../../images/simpleloading.gif";
import offlineImg from "./../../../images/offline.gif";
const mqtt = require("../../../mqtt/mqtt.js");
//http://localhost:3000/Surf/mobiledisplay/mac0-72-59/siteidTONYAZ/designtypeACGSTD

const Mobiledisplay = (props) => {
  const params = useParams();
  let mqttClient;
  const offlinetimeout = 60;
  const mobileBlueColor = "#00CED1";
  const mobileGreenColor = "#1efdaa";
  let isMobile = useCheckMobileScreen();
  let fistupdate = true;
  let vectorSize = useCheckMobileScreen() ? 2 : 4;
  let diagramFontSize = { fontSize: "14px" };
  let vectors = useRef({}); // reference variable
  const isfuelsaver = params.designtype.includes("FS");
  const [state, setState] = useStateIfMounted({
    surftype: "", //"AMFES"
    gstatus: "", //"Feeding The Load"
    grunning: "", //true
    gonload: "", //true
    ustatus: "", // "Utility Absent"
    urunning: "", //false
    uonload: "", //false
    Load: "",
    GPower: "",
    UPower: "",
    Inverter: "",
    PV: "",
    BatCurrent: "",
    BatCapacity: "",
    gridPV: "",
    OGIPowerSet: "",
    HybWarningStatus: "",
    HybFault: "",
    BatWarning: "",
    fistupdate: 0,
    designtype: params.designtype,
    siteid: params.siteid,
    mac: params.mac,
    online: true,
    gAlarm: "",
    gWarning: "",
    MinSoC: "",
    BatCap: "",
  });
  const diagramtopic =
    mqtt_topics.fixed_topic_part + state.mac + "/" + mqtt_topics.diagram_topic;

  function checkifemptystateofdata() {
    if (state.surftype == "" || state.surftype == undefined) {
      return true;
    }
    return false;
  }

  function requestdata() {
    mqtt_topics.busy_Requesting_Data = true;
    mqttClient.publish(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.request_topic,
      mqtt_topics.diagram_topic
    );
    mqtt_topics.busy_Requesting_Data = false;
    mqttClient.subscribe(diagramtopic);
    mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == diagramtopic) {
      try {
        // message is Buffer
        message = JSON.parse(message.toString());
        setState({
          ...state,
          surftype: message.Type == undefined ? "" : message.Type,
          gstatus: message.gstatus == undefined ? "" : message.gstatus,
          grunning:
            message.grunning == undefined
              ? false
              : message.grunning == 0
              ? false
              : true,
          gonload:
            message.gonload != undefined && Number(message.gonload) !== 0,
          ustatus: message.ustatus,
          urunning:
            message.urunning == undefined
              ? false
              : message.urunning == 0
              ? false
              : true,
          uonload:
            message.uonload == undefined
              ? false
              : message.uonload == 0
              ? false
              : true,
          Load:
            message.Load == undefined ? "" : Number(message.Load).toFixed(2), //localStorage.getItem("designtype") == "FSHYBRBS" ? Number(message.Load1) + Number(message.Load2) + Number(message.Load3)
          Load1:
            message.Load1 == undefined ? "" : Number(message.Load1).toFixed(2),
          Load2:
            message.Load2 == undefined ? "" : Number(message.Load2).toFixed(2),
          Load3:
            message.Load3 == undefined ? "" : Number(message.Load3).toFixed(2),
          Load1S: message.Load1S == undefined ? "" : Number(message.Load1S),
          Load2S: message.Load2S == undefined ? "" : Number(message.Load2S),
          Load3S: message.Load3S == undefined ? "" : Number(message.Load3S),
          UPower:
            message.UPower == undefined
              ? "0"
              : Number(message.UPower).toFixed(2),
          GPower:
            message.GPower == undefined
              ? "0"
              : Number(message.GPower).toFixed(2),
          Inverter:
            message.Inverter == undefined
              ? "0"
              : Number(message.Inverter).toFixed(2),
          PV:
            message.PV == undefined
              ? message.HybPV == undefined
                ? "0"
                : Number(message.HybPV).toFixed(2)
              : Number(message.PV).toFixed(2),
          BatCurrent:
            message.BatCurrent == undefined
              ? message.BatPower == undefined
                ? "0"
                : Number(message.BatPower)
              : Number(message.BatCurrent),
          BatCapacity:
            message.BatCapacity == undefined
              ? "0"
              : Number(message.BatCapacity),
          gridPV:
            message.gridPV == undefined
              ? message.OGIPV == undefined
                ? "0"
                : Number(message.OGIPV).toFixed(2)
              : Number(message.gridPV).toFixed(2),
          OGIPowerSet:
            message.OGIPowerSet == undefined
              ? "0"
              : Number(message.OGIPowerSet).toFixed(2),
          HybWarningStatus:
            message.HybWarningStatus == undefined
              ? ""
              : message.HybWarningStatus,
          HybFault: message.HybFault == undefined ? "" : message.HybFault,
          BatWarning: message.BatWarning == undefined ? "" : message.BatWarning,
          gAlarm:
            message.gAlarm == undefined
              ? ""
              : Array.isArray(message.gAlarm)
              ? message.gAlarm.join(" ")
              : message.gAlarm,
          gWarning:
            message.gWarning == undefined
              ? ""
              : Array.isArray(message.gWarning)
              ? message.gWarning.join(" ")
              : message.gWarning,
          MinSoC: message.MinSoC == undefined ? "" : message.MinSoC,
          BatCap: message.BatCap == undefined ? "" : message.BatCap,
          online: true,
          fistupdate: state.fistupdate++,
        });
      } catch (error) {
        console.log(message);
      }
    } else if (
      topic ==
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.stillpresent_topic
    ) {
      //console.log("recieved user presence");
      if (!mqtt_topics.busy_Requesting_Data) {
        returnuserpresence();
      } else {
        setTimeout(function () {
          returnuserpresence();
        }, mqtt_topics.timeouttotrytorequestmqttdata);
      }
    }
    mqtt_topics.lasttimegotlivedata = Math.floor(Date.now() / 1000);
  } //state.designtype
  function updatearrowsaccordingtonewdata() {
    // helper to coerce to number safely
    const safeNum = (v, fallback = 0) => {
      const n = Number(v);
      return isFinite(n) ? n : fallback;
    };

    // helper to format percent or empty
    const safePercent = (numerator, denominator) => {
      const num = safeNum(numerator, 0);
      const den = safeNum(denominator, 0);
      if (den === 0) return "";
      const pct = Math.round((num * 100) / den);
      return `${pct}%`;
    };

    // normalized state numbers used by multiple branches
    const UPower = safeNum(state.UPower, 0);
    const PV = safeNum(state.PV, 0);
    const BatCurrent = safeNum(state.BatCurrent, 0);
    const BatPower = safeNum(state.BatPower, 0);
    const GPower = safeNum(state.GPower, 0);
    const Load = safeNum(state.Load, 0);

    let designwithbatteries =
      state.designtype == "FSHYB" ||
      state.designtype == "FSCOMPHYB" ||
      state.designtype == "FSHYBRBS";

    // tower -> load
    createAndUpdateVectors(
      "towercell",
      "loadcell",
      state.uonload,
      "grid",
      "right",
      "right",
      "",
      "",
      "",
      "",
      state.designtype == "FSOG" ? 10 : ""
    );

    if (state.designtype == "FSOG") {
      // only for ongrid one: inverter -> tower when exporting
      createAndUpdateVectors(
        "inverter",
        "towercell",
        UPower < 0,
        "grid",
        "top",
        "right",
        "",
        "",
        "" //UPower < 0 ? Math.abs(UPower) + "kW Exported" : ""
      );
    } else {
      createAndUpdateVectors(
        "towercell",
        "inverter",
        state.uonload && designwithbatteries && state.UPower > 0,
        "grid",
        "right",
        "top",
        "", //state.UPower > 0 ? state.UPower + "kW Imported" :
        "",
        ""
      );
      createAndUpdateVectors(
        "inverter",
        "towercell",
        state.uonload && designwithbatteries && state.UPower < 0,
        "grid",
        "top",
        "right",
        "",
        "",
        "" //state.UPower < 0 ? state.UPower * -1 + "kW Exported" :
      );
    }

    // ---------- GENERATOR related branches (made numeric-safe) ----------

    // condition: generator -> inverter when generator feeding battery (charging)
    // original: Math.abs(state.BatCurrent).toFixed(2) - state.PV > 0
    const batCurrentRounded = Number(Math.abs(BatCurrent).toFixed(2));
    const genToInvCondition =
      state.gonload && designwithbatteries && batCurrentRounded - PV > 0;

    createAndUpdateVectors(
      "generatorcell",
      "inverter",
      genToInvCondition,
      "grid",
      "left",
      "top",
      "",
      "",
      // endLabel: (100 - (state.Load * 100) / state.GPower).toFixed(0) + "% Stored"
      // make it safe:
      "" /*(() => {
        if (!GPower) return "";
        const val = 100 - Math.round((Load * 100) / GPower);
        return `${val}%${isMobile ? "" : " Stored"}`;
      })()*/,
      "",
      "",
      "" //[2, -30]
    );

    // when batteries are full or pv production is more than charging current:
    // original: (state.PV - parseFloat(Math.abs(state.BatCurrent).toFixed(2))).toFixed(2) > 0
    const pvMinusBat = Number((PV - batCurrentRounded).toFixed(2));
    const invToGenCondition =
      state.gonload && designwithbatteries && pvMinusBat > 0;

    /* createAndUpdateVectors(
      "inverter",
      "generatorcell",
      invToGenCondition,
      "grid",
      "top",
      "left",
      pvMinusBat.toFixed(2) + "kW " + (isMobile ? "FL" : "Feeding Load"),
      "",
      "",
      [2, -30]
    );*/

    createAndUpdateVectors(
      "inverter",
      "generatorcell",
      invToGenCondition,
      "grid",
      "top",
      "left",
      "",
      "",
      "",
      "",
      ""
    );

    // generator -> load (produced)
    /*createAndUpdateVectors(
      "generatorcell",
      "loadcell",
      state.gonload,
      "grid",
      "left",
      "top",
      // label: state.GPower + "kW produced"
      GPower + "kW produced",
      "",
      // complex stored/consumed label: simplify & safe
      designwithbatteries
        ? (() => {
            const effectiveBat =
              !isFinite(BatCurrent) && !isFinite(BatPower)
                ? 0
                : BatCurrent || BatPower || 0;
            // compare effectiveBat - PV < 0 ? "100%" : ((Load*100)/GPower).toFixed(0) + "% Consumed"
            if (effectiveBat - PV < 0) return "100%";
            if (!GPower) return "";
            const pct = Math.round((Load * 100) / GPower);
            return !isNaN(pct) ? `${pct}%${isMobile ? "" : " Consumed"}` : "";
          })()
        : "",
      "",
      "",
      [2, -30]
    );*/
    createAndUpdateVectors(
      "generatorcell",
      "loadcell",
      state.gonload,
      "grid",
      "left",
      "top",
      "",
      "",
      "",
      "",
      ""
    );

    // battery <-> inverter direction based on BatCurrent/BatPower (safe)
    //const currentVal = Number(BatCurrent ?? BatPower ?? 0); // use BatCurrent, else BatPower, else 0
    //let currentVal = 0;
    //if (BatCurrent != null) currentVal = Number(BatCurrent);
    //else if (BatPower != null) currentVal = Number(BatPower);

    //const batteryIsCharging = currentVal > 0;

    /*createAndUpdateVectors(
      batteryIsCharging ? "inverter" : "battery",
      batteryIsCharging ? "battery" : "inverter",
      true,
      "straight",
      batteryIsCharging ? "bottom" : "top",
      batteryIsCharging ? "top" : "bottom"
    );*/
    const batValue =
      state.BatCurrent !== undefined
        ? Number(state.BatCurrent)
        : state.BatPower !== undefined
        ? Number(state.BatPower)
        : 0;

    // First direction
    createAndUpdateVectors(
      "inverter",
      "battery",
      batValue > 0,
      "straight",
      "bottom",
      "top"
    );

    // Reverse direction
    createAndUpdateVectors(
      "battery",
      "inverter",
      batValue <= 0,
      "straight",
      "top",
      "bottom"
    );

    // pv -> inverter
    createAndUpdateVectors(
      "pv",
      "inverter",
      PV > 0,
      "straight",
      "left",
      "right"
    );

    // inverter -> load
    createAndUpdateVectors(
      "inverter",
      "loadcell",
      (designwithbatteries && !state.gonload && !state.uonload) ||
        (!designwithbatteries && PV > 0),
      designwithbatteries ? "straight" : "grid",
      designwithbatteries ? "left" : state.uonload ? "left" : "top",
      designwithbatteries ? "right" : state.gonload ? "top" : "right",
      "",
      "",
      "",
      "",
      isMobile
        ? 26
        : state.uonload
        ? 77
        : state.surftype.toLowerCase().indexOf("amf") !== -1
        ? 77
        : 71
    );

    // gridpv -> ongridinverter
    createAndUpdateVectors(
      "gridpv",
      "ongridinverter",
      state.gridPV > 0 && state.designtype == "FSCOMPHYB",
      "straight",
      "left",
      "right"
    );

    // ongrid -> inverter (workaround)
    createAndUpdateVectors(
      "ongridinverter",
      "inverter",
      state.gridPV > 0 &&
        state.uonload == 0 &&
        state.gonload == 0 &&
        state.designtype == "FSCOMPHYB",
      "grid",
      "left",
      "left"
    );

    createAndUpdateVectors(
      "ongridinverter",
      "generatorcell",
      state.gridPV > 0 && state.gonload > 0 && state.designtype == "FSCOMPHYB",
      "grid",
      "top",
      "left"
    );

    createAndUpdateVectors(
      "ongridinverter",
      "towercell",
      state.gridPV > 0 &&
        state.uonload != 0 &&
        state.UPower != 0 &&
        state.designtype == "FSCOMPHYB",
      "grid",
      "top",
      "right"
    );

    if (state.designtype == "FSHYBRBS") {
      createAndUpdateVectors(
        "inverter",
        "loadcell1",
        state.Load1S > 0 && state.Load1 > 0,
        "grid",
        "left",
        "right"
      );
      createAndUpdateVectors(
        "inverter",
        "loadcell2",
        state.Load2S > 0 && state.Load2 > 0,
        "grid",
        "left",
        "right"
      );
      createAndUpdateVectors(
        "inverter",
        "loadcell3",
        state.Load3S > 0 && state.Load3 > 0,
        "grid",
        "left",
        "right"
      );
    }
  }

  function calculateChargingOrDischargingTime() {
    let time;
    let label;

    // --- Detect equalizing ---
    const isEqualizing =
      state.BatCurrent > 0 && // AC charging connected
      state.BatCurrent < 1 && // Current below threshold
      state.BatCapacity >= 95; // High SoC

    if (isEqualizing) {
      return "Battery full (equalizing)";
    }

    if (state.BatCurrent > 0) {
      // --- Charging ---
      let taperFactor = 1;

      if (state.BatCapacity > 90) {
        // Smooth taper between 90–95%
        // At 90% → taperFactor = 1
        // At 95% → taperFactor = 0.3 (example)
        //const soc = state.BatCapacity;
        //taperFactor = 1 - ((soc - 90) / 5) * 0.7; // 90%→1, 95%→0.3
        const socRatio = (state.BatCapacity - 90) / 7; // 90–97% → 0–1
        taperFactor = Math.pow(1 - socRatio, 2); // quadratic
        if (taperFactor < 0.2) taperFactor = 0.2; // never drop below 0.2
      }

      time =
        ((state.BatCap * (1 - state.BatCapacity / 100)) / state.BatCurrent) *
        taperFactor;
      label = "Time to full charge: ";
    } else {
      // --- Discharging ---
      time =
        (state.BatCap * ((state.BatCapacity - state.MinSoC) / 100)) /
        Math.abs(state.BatCurrent);
      label = "Time to discharge: ";
    }

    // Convert time (in hours) to hh:mm
    const hours = Math.floor(Math.abs(time));
    const minutes = Math.floor((Math.abs(time) - hours) * 60);

    return (
      label +
      `${hours.toString().padStart(2, "0")}h ${minutes
        .toString()
        .padStart(2, "0")}m`
    );
  }

  useEffect(() => {
    //(mqtt_topics.choosenid == "SAS45K" ? 3 : 1)
    if (state.fistupdate > 1 && isfuelsaver) {
      updatearrowsaccordingtonewdata();
    }
  }, [state]);

  useEffect(() => {
    mqtt_topics.lasttimegotlivedata = Math.floor(Date.now() / 1000);
    fistupdate = true;
    mqtt_topics.categories_User_Iswatching = [
      '"Close ' + mqtt_topics.diagram_topic + '"',
    ];
    mqttClient = mqtt.connect();
    mqttClient.setMaxListeners(0);

    mqttClient.subscribe(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.stillpresent_topic
    );

    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata();
    } else {
      setTimeout(function () {
        requestdata();
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
    clearsallvectors();
    const interval = setInterval(() => {
      keepcheckingifoffline();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  function returnuserpresence() {
    mqtt_topics.busy_Requesting_Data = true;
    mqttClient.publish(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.request_topic,
      "User Alive"
    );
    mqtt_topics.busy_Requesting_Data = false;
  }

  useEffect(() => {
    window.onbeforeunload = (e) => {
      handlepageexixt();
    };
  }, []);

  function handlepageexixt() {
    mqttClient.unsubscribe(diagramtopic);
    mqttClient.unsubscribe(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.stillpresent_topic
    );
    mqttClient.removeListener("message", handleMqttMessage);
    console.log(mqtt_topics.categories_User_Iswatching);
    mqttClient.publish(
      mqtt_topics.fixed_topic_part + state.mac + mqtt_topics.request_topic,
      JSON.parse(
        JSON.stringify(
          '{ "' +
            mqtt_topics.finishedofalllivereadings +
            '" : [' +
            mqtt_topics.categories_User_Iswatching +
            "] }"
        )
      )
    );
    clearsallvectors();
    // I'm about to refresh! do something...
    if (mqttClient != undefined && mqttClient.connected) {
      mqttClient.end();
    }
  }

  function keepcheckingifoffline() {
    let now = Math.floor(Date.now() / 1000);
    if (now - mqtt_topics.lasttimegotlivedata > offlinetimeout) {
      clearsallvectors();
      setState({ ...state, online: false });
    }
  }

  //when componenet unmount
  useEffect(
    () => () => {
      handlepageexixt();
      clearsallvectors();
      //console.log("diagram component unmount");
    },
    []
  );

  function clearsallvectors() {
    Object.keys(vectors).map(function (key) {
      try {
        vectors[key].remove();
      } catch (Exception) {
        //console.log(Exception);
      }
    });
    vectors = {};
  }

  function displayled(where) {
    switch (where) {
      case "urunning":
        return state.urunning ? red_onIndicator : red_offIndicator;

      case "uonload":
        return state.uonload ? green_onIndicator : green_offIndicator;

      case "grunning":
        return state.grunning ? red_onIndicator : red_offIndicator;

      case "gonload":
        return state.gonload ? green_onIndicator : green_offIndicator;

      default:
        return undefined;
    }
  }
  /*function createAndUpdateVectors(
    from,
    to,
    onload,
    path,
    startSocket,
    endSocket,
    startLabel,
    middleLabel,
    endLabel,
    startoffset,
    startSocketGravity,
    endoffset
  ) {
    const fromEl = document.getElementById(from);
    const toEl = document.getElementById(to);

    if (!fromEl || !toEl) return;

    const fromRect = fromEl.getBoundingClientRect();
    const toRect = toEl.getBoundingClientRect();

    // ❌ Skip drawing if any element has 0 width or height
    if (
      fromRect.width === 0 ||
      fromRect.height === 0 ||
      toRect.width === 0 ||
      toRect.height === 0
    )
      return;

    const target = `${from}_${to}`;
    const oppositTarget = `${to}_${from}`;

    if (onload) {
      const options = {
        startPlugColor: mobileBlueColor,
        endPlugColor: mobileGreenColor,
        gradient: true,
        dash: { animation: true },
        path,
        startSocket,
        endSocket,
        size: vectorSize,
        startLabel: LeaderLine.captionLabel(startLabel, {
          color: mobileBlueColor,
          offset: startoffset,
          outlineColor: "transparent",
        }),
        middleLabel: LeaderLine.captionLabel(middleLabel, {
          color: mobileBlueColor,
          outlineColor: "transparent",
        }),
        endLabel: LeaderLine.captionLabel(endLabel, {
          color: mobileGreenColor,
          offset: endoffset,
          outlineColor: "transparent",
        }),
        startSocketGravity,
        endPlug:
          from === "ongridinverter" || to === "generatorcell"
            ? "behind"
            : "arrow1",
      };

      if (vectors.current[target]) {
        try {
          vectors.current[target].setOptions(options);
        } catch {
          vectors.current[target] = new LeaderLine(fromEl, toEl, options);
        }
      } else {
        vectors.current[target] = new LeaderLine(fromEl, toEl, options);
      }

      if (vectors.current[oppositTarget]) {
        try {
          vectors.current[oppositTarget].remove();
        } catch {}
        delete vectors.current[oppositTarget];
      }
    } else {
      // remove current line safely
      if (vectors.current[target]) {
        try {
          vectors.current[target].remove();
        } catch {}
        delete vectors.current[target];
      }
      if (vectors.current[oppositTarget]) {
        try {
          vectors.current[oppositTarget].remove();
        } catch {}
        delete vectors.current[oppositTarget];
      }
    }
  }*/
  function createAndUpdateVectorsSafe(
    fromId,
    toId,
    onload,
    path,
    startSocket,
    endSocket,
    startLabel,
    middleLabel,
    endLabel,
    startoffset,
    startSocketGravity,
    endoffset
  ) {
    if (!onload) return;

    const fromEl = document.getElementById(fromId);
    const toEl = document.getElementById(toId);

    let retries = 0;
    const maxRetries = 25;

    function tryDraw() {
      if (retries++ > maxRetries) {
        console.warn(
          `LeaderLine draw failed: max retries exceeded for ${fromId} -> ${toId}`
        );
        return;
      }

      if (!fromEl || !toEl) {
        setTimeout(tryDraw, 200);
        return;
      }

      const fromRect = fromEl.getBoundingClientRect();
      const toRect = toEl.getBoundingClientRect();

      if (
        !fromRect.width ||
        !fromRect.height ||
        !toRect.width ||
        !toRect.height
      ) {
        setTimeout(tryDraw, 200);
        return;
      }

      if (
        !isFinite(fromRect.x) ||
        !isFinite(fromRect.y) ||
        !isFinite(toRect.x) ||
        !isFinite(toRect.y)
      ) {
        setTimeout(tryDraw, 200);
        return;
      }

      const target = `${fromId}_${toId}`;
      const oppositTarget = `${toId}_${fromId}`;

      const options = {
        startPlugColor: "#4a90e2",
        endPlugColor: "#00c853",
        gradient: true,
        dash: { animation: true },
        path: path || "grid",
        startSocket,
        endSocket,
        size: 2,
        startLabel: startLabel
          ? LeaderLine.captionLabel(startLabel, {
              color: "#4a90e2",
              offset: startoffset || 0,
              outlineColor: "transparent",
            })
          : null,
        middleLabel: middleLabel
          ? LeaderLine.captionLabel(middleLabel, {
              color: "#4a90e2",
              outlineColor: "transparent",
            })
          : null,
        endLabel: endLabel
          ? LeaderLine.captionLabel(endLabel, {
              color: "#00c853",
              offset: endoffset || 0,
              outlineColor: "transparent",
            })
          : null,
        startSocketGravity: startSocketGravity || 0,
        endPlug: "arrow1",
      };

      try {
        if (vectors.current[target]) {
          vectors.current[target].setOptions(options);
        } else {
          vectors.current[target] = new LeaderLine(fromEl, toEl, options);
        }
        if (vectors.current[oppositTarget]) {
          vectors.current[oppositTarget].remove();
          delete vectors.current[oppositTarget];
        }
      } catch (e) {
        console.warn("LeaderLine draw failed", e);
      }
    }

    // Wait for images inside elements
    const imgs = [
      ...(fromEl ? fromEl.querySelectorAll("img") : []),
      ...(toEl ? toEl.querySelectorAll("img") : []),
    ];

    const allImgsLoaded = imgs.every((img) => img.complete);

    if (allImgsLoaded) {
      requestAnimationFrame(tryDraw);
    } else {
      imgs.forEach(
        (img) => (img.onload = () => requestAnimationFrame(tryDraw))
      );
    }
  }

  function createAndUpdateVectors(
    from,
    to,
    onload,
    path,
    startSocket,
    endSocket,
    startLabel,
    middleLabel,
    endLabel,
    startoffset,
    startSocketGravity,
    endoffset
  ) {
    /*console.log(">>> Original parameters:");
    console.log({
      from,
      to,
      onload,
      path,
      startSocket,
      endSocket,
      startLabel,
      middleLabel,
      endLabel,
      startoffset,
      startSocketGravity,
      endoffset,
    });*/

    // Coerce onload to boolean
    onload = !!+onload;

    // Normalize endLabel for negative percentages safely
    if (typeof endLabel === "string" && endLabel.includes("%")) {
      const num = parseFloat(endLabel);
      endLabel = isNaN(num) ? 0 : Math.abs(num); // numeric only
    }

    // --- Offset normalization ---
    function normalizeOffset(offset, defaultX = 0, defaultY = 0) {
      if (!offset) return { x: defaultX, y: defaultY };

      let x = defaultX,
        y = defaultY;

      if (Array.isArray(offset) && offset.length === 2) {
        x = Number(offset[0]);
        y = Number(offset[1]);
      } else if (typeof offset === "string") {
        const parts = offset.split(",").map((p) => parseFloat(p.trim()));
        if (parts.length === 2) {
          x = isNaN(parts[0]) ? defaultX : parts[0];
          y = isNaN(parts[1]) ? defaultY : parts[1];
        }
      } else if (typeof offset === "object") {
        x = !isNaN(offset.x) ? offset.x : defaultX;
        y = !isNaN(offset.y) ? offset.y : defaultY;
      }

      return { x, y };
    }

    startoffset = normalizeOffset(startoffset, 0, 0);
    endoffset = normalizeOffset(endoffset, 0, 0);

    /*console.log(">>> Normalized parameters:");
    console.log({
      startoffset,
      endoffset,
      endLabel,
    });*/

    const fromEl = document.getElementById(from);
    const toEl = document.getElementById(to);
    if (!fromEl || !toEl) {
      //console.warn(">>> One or both elements not found:", from, to);
      return;
    }

    const target = `${from}_${to}`;
    const oppositTarget = `${to}_${from}`;
    const MAX_RETRIES = 3;
    const RETRY_DELAY_MS = 150;

    function isValidRect(r) {
      return (
        r &&
        isFinite(r.left) &&
        isFinite(r.top) &&
        isFinite(r.width) &&
        isFinite(r.height) &&
        r.width > 0 &&
        r.height > 0
      );
    }

    function tryCreate(attempt = 0) {
      let fromRect, toRect;
      try {
        fromRect = fromEl.getBoundingClientRect();
        toRect = toEl.getBoundingClientRect();
      } catch (e) {
        fromRect = null;
        toRect = null;
      }

      if (!isValidRect(fromRect) || !isValidRect(toRect)) {
        if (attempt < MAX_RETRIES) {
          setTimeout(() => tryCreate(attempt + 1), RETRY_DELAY_MS);
        } else {
          [target, oppositTarget].forEach((t) => {
            if (vectors.current[t]) {
              try {
                vectors.current[t].remove();
              } catch {}
              delete vectors.current[t];
            }
          });
        }
        return;
      }
      /*console.log(">>> checked parameters:");
      console.log({
        from,
        to,
        onload,
        path,
        startSocket,
        endSocket,
        startLabel,
        middleLabel,
        endLabel,
        startoffset,
        startSocketGravity,
        endoffset,
      });*/
      const options = {
        startPlugColor: mobileBlueColor,
        endPlugColor: mobileGreenColor,
        gradient: true,
        dash: { animation: true },
        path,
        startSocket,
        endSocket,
        size: vectorSize,
        startLabel: startLabel
          ? LeaderLine.captionLabel(startLabel, {
              color: mobileBlueColor,
              offset: startoffset,
              outlineColor: "transparent",
            })
          : null,
        middleLabel: middleLabel
          ? LeaderLine.captionLabel(middleLabel, {
              color: mobileBlueColor,
              outlineColor: "transparent",
            })
          : null,
        endLabel: endLabel
          ? LeaderLine.captionLabel(endLabel, {
              color: mobileGreenColor,
              offset: endoffset,
              outlineColor: "transparent",
            })
          : null,
        startSocketGravity: Number(startSocketGravity) || 0, // <-- force number
        endPlug:
          from === "ongridinverter" || to === "generatorcell"
            ? "behind"
            : "arrow1",
      };

      if (onload) {
        if (vectors.current[target]) {
          try {
            vectors.current[target].setOptions(options);
          } catch {
            vectors.current[target] = new LeaderLine(fromEl, toEl, options);
          }
        } else {
          vectors.current[target] = new LeaderLine(fromEl, toEl, options);
        }

        /*if (vectors.current[oppositTarget]) {
          try {
            vectors.current[oppositTarget].remove();
          } catch {}
          delete vectors.current[oppositTarget];
        }*/
      } else {
        [target].forEach((t) => {
          if (vectors.current[t]) {
            try {
              vectors.current[t].remove();
            } catch {}
            delete vectors.current[t];
          }
        });
      }
    }

    window.requestAnimationFrame(() => tryCreate(0));
  }

  /*function createAndUpdateVectors(
    from,
    to,
    onload,
    path,
    startSocket,
    endSocket,
    startLabel,
    middleLabel,
    endLabel,
    startoffset,
    startSocketGravity,
    endoffset
  ) {
    const fromEl = document.getElementById(from);
    const toEl = document.getElementById(to);

    if (!fromEl || !toEl) return; // early return if not rendered

    const target = `${from}_${to}`;
    const oppositTarget = `${to}_${from}`;

    if (onload) {
      const options = {
        startPlugColor: mobileBlueColor,
        endPlugColor: mobileGreenColor,
        gradient: true,
        dash: { animation: true },
        path,
        startSocket,
        endSocket,
        size: vectorSize,
        startLabel: LeaderLine.captionLabel(startLabel, {
          color: mobileBlueColor,
          offset: startoffset,
          outlineColor: "transparent",
        }),
        middleLabel: LeaderLine.captionLabel(middleLabel, {
          color: mobileBlueColor,
          outlineColor: "transparent",
        }),
        endLabel: LeaderLine.captionLabel(endLabel, {
          color: mobileGreenColor,
          offset: endoffset,
          outlineColor: "transparent",
        }),
        startSocketGravity,
        endPlug:
          from === "ongridinverter" || to === "generatorcell"
            ? "behind"
            : "arrow1",
      };

      // Create or update current line
      if (vectors.current[target]) {
        try {
          vectors.current[target].setOptions(options);
        } catch {
          vectors.current[target] = new LeaderLine(fromEl, toEl, options);
        }
      } else {
        vectors.current[target] = new LeaderLine(fromEl, toEl, options);
      }

      // Always remove only the opposite line
      if (vectors.current[oppositTarget]) {
        try {
          vectors.current[oppositTarget].remove();
        } catch {}
        delete vectors.current[oppositTarget];
      }
    } else {
      // ❗ Remove only the current line
      if (vectors.current[target]) {
        try {
          vectors.current[target].remove();
        } catch {}
        delete vectors.current[target];
      }

      if (vectors.current[oppositTarget]) {
        try {
          vectors.current[oppositTarget].remove();
        } catch {}
        delete vectors.current[oppositTarget];
      }
    }
  }*/

  function round20(x) {
    //return Math.ceil(x / 20) * 20; //round up
    //return Math.round(x / 20) * 20;//round down
    if (x >= 90) {
      return 100;
    } else if (x >= 70) {
      return 80;
    } else if (x >= 50) {
      return 60;
    } else if (x >= 30) {
      return 40;
    } else if (x >= 10) {
      return 20;
    } else if (x >= 0) {
      return 0;
    }
  }

  const getBatteryImage = (capacity, charging, warning) => {
    if (warning === "Communication Lost") return batteryAlertImg;
    if (charging > 0) return batteryChargingGif;

    switch (Math.round(capacity / 20) * 20) {
      case 0:
        return battery0;
      case 20:
        return battery20;
      case 40:
        return battery40;
      case 60:
        return battery60;
      case 80:
        return battery80;
      case 100:
        return battery100;
      default:
        return battery0;
    }
  };

  if (state.online) {
    if (checkifemptystateofdata()) {
      return (
        <div className="container" style={diagramFontSize}>
          <div className="col text-white">
            <div>
              <center>
                <img src={loadingImg} className="simpleloadingview" />
                <p>
                  <strong>Loading Circuit Diagram ...</strong>
                </p>
              </center>
            </div>
          </div>
        </div>
      );
    } else {
      if (state.surftype.toLowerCase().indexOf("amf") !== -1) {
        switch (state.designtype) {
          case "FSHYBRBS":
            {
              //fuel save hybrid inverter
              return (
                <div className="row" style={diagramFontSize}>
                  <div className="col">
                    <div className=" text-center text-white  mobilelivediagramcards">
                      <div className="card-body ">
                        <table align="center">
                          <tbody>
                            <tr>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  {state.ustatus}
                                </p>
                              </td>
                              <td colSpan="1">
                                <hr className="vr" />
                              </td>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  {state.gstatus}
                                  {state.gAlarm !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#cc3300" }}>
                                        {state.gAlarm}
                                      </span>
                                    </>
                                  )}
                                  {state.gWarning !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#ffcc00" }}>
                                        {state.gWarning}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("urunning")}
                                    title="Utility Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("uonload")}
                                    title="Utility Onload Led"
                                  />
                                </div>
                              </td>
                              <td colSpan="3"></td>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("grunning")}
                                    title="Genset Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("gonload")}
                                    title="Genset Onload Led"
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FStowercell"
                                    src={towerImg}
                                    title="Utility Tower"
                                    id="towercell"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.UPower > 0
                                          ? "mobilebluetext"
                                          : "greentext"
                                      }
                                    >
                                      {state.UPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSgeneratorcell"
                                    src={generatorImg}
                                    title="Generator"
                                    id="generatorcell"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.GPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2">
                                <div>
                                  <figure>
                                    <img
                                      className="FS3loadcell"
                                      src={
                                        state.Load1S > 0
                                          ? onloadImg
                                          : offloadImg
                                      }
                                      title="First Load"
                                      id="loadcell1"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load1 + "kW"}
                                      </strong>
                                      <br />
                                    </figcaption>
                                    <img
                                      className="FS3loadcell"
                                      src={
                                        state.Load2S > 0
                                          ? onloadImg
                                          : offloadImg
                                      }
                                      title="Second Load"
                                      id="loadcell2"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load2 + "kW"}
                                      </strong>
                                      <br />
                                    </figcaption>
                                    <img
                                      className="FS3loadcell"
                                      src={
                                        state.Load3S > 0
                                          ? onloadImg
                                          : offloadImg
                                      }
                                      title="Third Load"
                                      id="loadcell3"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load3 + "kW"}
                                      </strong>
                                      <br />
                                      <strong>Consumption</strong>
                                    </figcaption>
                                  </figure>
                                </div>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={inverterImg}
                                    style={{ height: "", width: "" }}
                                    title="Power Inverter"
                                    id="inverter"
                                  />
                                  <figcaption>
                                    <strong>&nbsp; &nbsp;</strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={pvImg}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="pv"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.PV + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Solar Panels</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSbatterycell"
                                    src={getBatteryImage(
                                      state.BatCapacity,
                                      state.BatCurrent,
                                      state.BatWarning
                                    )}
                                    style={{ height: "", width: "" }}
                                    id="battery"
                                    title="Battery"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.BatCurrent > 0
                                          ? "greentext"
                                          : "mobilebluetext"
                                      }
                                    >
                                      {state.BatCurrent + "kW"}
                                      <br />
                                      {"[" + state.BatCapacity + "% full]"}
                                    </strong>
                                    <br />
                                    <strong>Battery</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <strong>
                                  {state.HybWarningStatus !== "" && (
                                    <>
                                      Inverter Status: {state.HybWarningStatus}
                                      <br />
                                    </>
                                  )}
                                </strong>
                                <strong>
                                  {state.HybFault != ""
                                    ? "Inverter Fault: " + state.HybFault
                                    : ""}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div></div>
                        {state.MinSoC != undefined &&
                          state.MinSoC != "" &&
                          state.BatCap != undefined &&
                          state.BatCap != "" &&
                          state.BatCapacity != 100 &&
                          state.BatCurrent != 0 && (
                            <strong
                              className={
                                state.BatCurrent > 0
                                  ? "greentext"
                                  : "mobilebluetext"
                              }
                            >
                              {calculateChargingOrDischargingTime()}
                            </strong>
                          )}
                      </div>
                      <strong>-{" " + mqtt_topics.choosenid + " "}-</strong>
                      <br />
                    </div>
                  </div>
                </div>
              );
            }
            break;
          case "FSHYB":
            {
              //fuel save hybrid inverter
              return (
                <div className="row" style={diagramFontSize}>
                  <div className="col">
                    <div className=" text-center text-white  mobilelivediagramcards">
                      <div className="card-body ">
                        <table align="center">
                          <tbody>
                            <tr>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  Utlity Status: {state.ustatus}
                                </p>
                              </td>
                              <td colSpan="1">
                                <hr className="vr" />
                              </td>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  {state.gstatus}
                                  {state.gAlarm !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#cc3300" }}>
                                        {state.gAlarm}
                                      </span>
                                    </>
                                  )}
                                  {state.gWarning !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#ffcc00" }}>
                                        {state.gWarning}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("urunning")}
                                    title="Utility Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("uonload")}
                                    title="Utility Onload Led"
                                  />
                                </div>
                              </td>
                              <td colSpan="3"></td>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("grunning")}
                                    title="Genset Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("gonload")}
                                    title="Genset Onload Led"
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FStowercell"
                                    src={towerImg}
                                    title="Utility Tower"
                                    id="towercell"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.UPower > 0
                                          ? "mobilebluetext"
                                          : "greentext"
                                      }
                                    >
                                      {state.UPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSgeneratorcell"
                                    src={generatorImg}
                                    title="Generator"
                                    id="generatorcell"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.GPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr></tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2">
                                <div>
                                  <figure>
                                    <img
                                      className="FSloadcell"
                                      src={homeImg}
                                      title="Load"
                                      style={{ height: "", width: "" }}
                                      id="loadcell"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load + "kW"}
                                      </strong>
                                      <br />
                                      <strong>Consumption</strong>
                                    </figcaption>
                                  </figure>
                                </div>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={inverterImg}
                                    style={{ height: "", width: "" }}
                                    title="Power Inverter"
                                    id="inverter"
                                  />
                                  <figcaption>
                                    <strong>&nbsp; &nbsp;</strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={pvImg}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="pv"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.PV + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Solar Panels</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSbatterycell"
                                    src={getBatteryImage(
                                      state.BatCapacity,
                                      state.BatCurrent,
                                      state.BatWarning
                                    )}
                                    style={{ height: "", width: "" }}
                                    id="battery"
                                    title="Battery"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.BatCurrent > 0
                                          ? "greentext"
                                          : "mobilebluetext"
                                      }
                                    >
                                      {state.BatCurrent + "kW"}
                                      <br />
                                      {"[" + state.BatCapacity + "% full]"}
                                    </strong>
                                    <br />
                                    <strong>Battery</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <strong>
                                  {state.HybWarningStatus !== "" && (
                                    <>
                                      Inverter Status: {state.HybWarningStatus}
                                      <br />
                                    </>
                                  )}
                                </strong>
                                <strong>
                                  {state.HybFault != ""
                                    ? "Inverter Fault: " + state.HybFault
                                    : ""}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div></div>
                        {state.MinSoC != undefined &&
                          state.MinSoC != "" &&
                          state.BatCap != undefined &&
                          state.BatCap != "" &&
                          state.BatCapacity != 100 &&
                          state.BatCurrent != 0 && (
                            <strong
                              className={
                                state.BatCurrent > 0
                                  ? "greentext"
                                  : "mobilebluetext"
                              }
                            >
                              {calculateChargingOrDischargingTime()}
                            </strong>
                          )}
                      </div>
                      <strong>-{" " + params.siteid + " "}-</strong>
                      <br />
                    </div>
                  </div>
                </div>
              );
            }
            break;
          case "FSOG":
            {
              //fuel save on grid inverter
              return (
                <div className="row" style={diagramFontSize}>
                  <div className="col">
                    <div className="text-center text-white  mobilelivediagramcards">
                      <div className="card-body ">
                        <table align="center">
                          <tbody>
                            <tr>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  Utlity Status: {state.ustatus}
                                </p>
                              </td>
                              <td colSpan="1">
                                <hr className="vr" />
                              </td>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  Genset Status: {state.gstatus}
                                  {state.gAlarm !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#cc3300" }}>
                                        {state.gAlarm}
                                      </span>
                                    </>
                                  )}
                                  {state.gWarning !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#ffcc00" }}>
                                        {state.gWarning}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("urunning")}
                                    title="Utility Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("uonload")}
                                    title="Utility Onload Led"
                                  />
                                </div>
                              </td>
                              <td colSpan="3"></td>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("grunning")}
                                    title="Genset Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("gonload")}
                                    title="Genset Onload Led"
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FStowercell"
                                    src={towerImg}
                                    title="Utility Tower"
                                    id="towercell"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.UPower > 0
                                          ? "mobilebluetext"
                                          : "greentext"
                                      }
                                    >
                                      {state.UPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSgeneratorcell"
                                    src={generatorImg}
                                    title="Generator"
                                    id="generatorcell"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.GPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr></tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2">
                                <div>
                                  <figure>
                                    <img
                                      className="FSloadcell"
                                      src={homeImg}
                                      title="Load"
                                      style={{ height: "", width: "" }}
                                      id="loadcell"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load + "kW"}
                                      </strong>
                                      <br />
                                      <strong>Consumption</strong>
                                    </figcaption>
                                  </figure>
                                </div>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={onGridInverterImg}
                                    style={{ height: "", width: "" }}
                                    title="Power Inverter"
                                    id="inverter"
                                  />
                                  <figcaption>
                                    <strong>
                                      {state.OGIPowerSet != undefined
                                        ? "S" + state.OGIPowerSet + "kW"
                                        : ""}
                                    </strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={pvImg}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="pv"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.PV + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Solar Panels</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div></div>
                        {state.MinSoC != undefined &&
                          state.MinSoC != "" &&
                          state.BatCap != undefined &&
                          state.BatCap != "" &&
                          state.BatCapacity != 100 &&
                          state.BatCurrent != 0 && (
                            <strong
                              className={
                                state.BatCurrent > 0
                                  ? "greentext"
                                  : "mobilebluetext"
                              }
                            >
                              {calculateChargingOrDischargingTime()}
                            </strong>
                          )}
                      </div>
                      <strong>-{" " + params.siteid + " "}-</strong>
                      <br />
                    </div>
                  </div>
                </div>
              );
            }
            break;
          case "FSCOMPHYB":
            {
              // fuel save with ongrid and hybride inverter
              return (
                <div className="row" style={diagramFontSize}>
                  <div className="col">
                    <div className="text-center text-white  mobilelivediagramcards">
                      <div className="card-body ">
                        <table align="center">
                          <tbody>
                            <tr>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  Utlity Status: {state.ustatus}
                                </p>
                              </td>
                              <td colSpan="1">
                                <hr className="vr" />
                              </td>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  Genset Status: {state.gstatus}
                                  {state.gAlarm !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#cc3300" }}>
                                        {state.gAlarm}
                                      </span>
                                    </>
                                  )}
                                  {state.gWarning !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#ffcc00" }}>
                                        {state.gWarning}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("urunning")}
                                    title="Utility Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("uonload")}
                                    title="Utility Onload Led"
                                  />
                                </div>
                              </td>
                              <td colSpan="3"></td>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("grunning")}
                                    title="Genset Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("gonload")}
                                    title="Genset Onload Led"
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FStowercell"
                                    src={towerImg}
                                    title="Utility Tower"
                                    id="towercell"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.UPower > 0
                                          ? "mobilebluetext"
                                          : "greentext"
                                      }
                                    >
                                      {state.UPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSgeneratorcell"
                                    src={generatorImg}
                                    title="Generator"
                                    id="generatorcell"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.GPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="3"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={onGridInverterImg}
                                    style={{ height: "", width: "" }}
                                    title="Power Ongrid Inverter"
                                    id="ongridinverter"
                                  />
                                  <figcaption>
                                    <strong>
                                      {state.OGIPowerSet != undefined
                                        ? "S" + state.OGIPowerSet + "kW"
                                        : ""}
                                    </strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={pvImg}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="gridpv"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.gridPV + "kW"}
                                    </strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2">
                                <div>
                                  <figure>
                                    <img
                                      className="FSloadcell"
                                      src={homeImg}
                                      title="Load"
                                      style={{ height: "", width: "" }}
                                      id="loadcell"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load + "kW"}
                                      </strong>
                                      <br />
                                      <strong>Consumption</strong>
                                    </figcaption>
                                  </figure>
                                </div>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={inverterImg}
                                    style={{ height: "", width: "" }}
                                    title="Power Inverter"
                                    id="inverter"
                                  />
                                  <figcaption>
                                    <strong>&nbsp; &nbsp;</strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={pvImg}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="pv"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.PV + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Solar Panels</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSbatterycell"
                                    src={getBatteryImage(
                                      state.BatCapacity,
                                      state.BatCurrent,
                                      state.BatWarning
                                    )}
                                    style={{ height: "", width: "" }}
                                    id="battery"
                                    title="Battery"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.BatCurrent > 0
                                          ? "greentext"
                                          : "mobilebluetext"
                                      }
                                    >
                                      {state.BatCurrent + "kW"}
                                      <br />
                                      {"[" + state.BatCapacity + "% full]"}
                                    </strong>
                                    <br />
                                    <strong>Battery</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <strong>
                                  {state.HybWarningStatus !== "" && (
                                    <>
                                      Inverter Status: {state.HybWarningStatus}
                                      <br />
                                    </>
                                  )}
                                </strong>
                                <strong>
                                  {state.HybFault != ""
                                    ? "Inverter Fault: " + state.HybFault
                                    : ""}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div></div>
                        {state.MinSoC != undefined &&
                          state.MinSoC != "" &&
                          state.BatCap != undefined &&
                          state.BatCap != "" &&
                          state.BatCapacity != 100 &&
                          state.BatCurrent != 0 && (
                            <strong
                              className={
                                state.BatCurrent > 0
                                  ? "greentext"
                                  : "mobilebluetext"
                              }
                            >
                              {calculateChargingOrDischargingTime()}
                            </strong>
                          )}
                      </div>
                      <strong>-{" " + params.siteid + " "}-</strong>
                      <br />
                    </div>
                  </div>
                </div>
              );
            }
            break;
          case "ACGSTD": //standard AC Generator
          default: {
            return (
              <div className="row">
                <div className="col">
                  <div className="text-center text-white  mobilelivediagramcards">
                    <div className="card-body ">
                      <table align="center">
                        <tbody>
                          <tr>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                Utlity Status: {state.ustatus}
                              </p>
                            </td>
                            <td>
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                Genset Status: {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("urunning")}
                                  title="Utility Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("uonload")}
                                  title="Utility Onload Led"
                                />
                              </div>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table">
                              <img
                                className="towercell"
                                src={state.urunning ? towerOnImg : towerImg}
                                title="Utility Tower"
                              />
                            </td>
                            <td>
                              <img
                                src={
                                  state.uonload ? contactorClose : contactorOpen
                                }
                                className="contClose"
                                title="Contactor"
                              />
                            </td>
                            <td className="tr_inmode_table">
                              <img
                                className="loadcell"
                                src={loadImg}
                                title="Load"
                              />
                            </td>
                            <td>
                              <img
                                src={
                                  state.gonload ? contactorClose : contactorOpen
                                }
                                className="contClose"
                                title="Contactor"
                              />
                            </td>
                            <td className="tr_inmode_table">
                              <img
                                className="generatorcell"
                                src={state.grunning ? g1OnImg : g1offImg}
                                title="Generator"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                      {state.MinSoC != undefined &&
                        state.MinSoC != "" &&
                        state.BatCap != undefined &&
                        state.BatCap != "" &&
                        state.BatCapacity != 100 &&
                        state.BatCurrent != 0 && (
                          <strong
                            className={
                              state.BatCurrent > 0
                                ? "greentext"
                                : "mobilebluetext"
                            }
                          >
                            {calculateChargingOrDischargingTime()}
                          </strong>
                        )}
                    </div>
                    <strong>-{" " + params.siteid + " "}-</strong>
                  </div>
                </div>
              </div>
            );
          }
        }
      } else {
        switch (state.designtype) {
          case "FSHYBRBS": {
            //fuel save hybrid inverter
            return (
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className=" text-center text-white  mobilelivediagramcards">
                    <div className="card-body ">
                      <table align="center">
                        <tbody>
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td colSpan="3"></td>
                            <td>
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={generatorImg}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="mobilebluetext">
                                    {state.GPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FS3loadcell"
                                    src={
                                      state.Load1S > 0 ? onloadImg : offloadImg
                                    }
                                    title="First Load"
                                    id="loadcell1"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load1 + "kW"}
                                    </strong>
                                    <br />
                                  </figcaption>
                                  <img
                                    className="FS3loadcell"
                                    src={
                                      state.Load2S > 0 ? onloadImg : offloadImg
                                    }
                                    title="Second Load"
                                    id="loadcell2"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load2 + "kW"}
                                    </strong>
                                    <br />
                                  </figcaption>
                                  <img
                                    className="FS3loadcell"
                                    src={
                                      state.Load3S > 0 ? onloadImg : offloadImg
                                    }
                                    title="Third Load"
                                    id="loadcell3"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load3 + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={inverterImg}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>&nbsp; &nbsp;</strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={pvImg}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="mobilebluetext">
                                    {state.PV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSbatterycell"
                                  src={getBatteryImage(
                                    state.BatCapacity,
                                    state.BatCurrent,
                                    state.BatWarning
                                  )}
                                  style={{ height: "", width: "" }}
                                  id="battery"
                                  title="Battery"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.BatCurrent > 0
                                        ? "greentext"
                                        : "mobilebluetext"
                                    }
                                  >
                                    {state.BatCurrent + "kW"}
                                    <br />
                                    {"[" + state.BatCapacity + "% full]"}
                                  </strong>
                                  <br />
                                  <strong>Battery</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <strong>
                                {state.HybWarningStatus !== "" && (
                                  <>
                                    Inverter Status: {state.HybWarningStatus}
                                    <br />
                                  </>
                                )}
                              </strong>
                              <strong>
                                {state.HybFault != ""
                                  ? "Inverter Fault: " + state.HybFault
                                  : ""}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                      {state.MinSoC != undefined &&
                        state.MinSoC != "" &&
                        state.BatCap != undefined &&
                        state.BatCap != "" &&
                        state.BatCapacity != 100 &&
                        state.BatCurrent != 0 && (
                          <strong
                            className={
                              state.BatCurrent > 0
                                ? "greentext"
                                : "mobilebluetext"
                            }
                          >
                            {calculateChargingOrDischargingTime()}
                          </strong>
                        )}
                    </div>
                    <strong>-{" " + mqtt_topics.choosenid + " "}-</strong>
                    <br />
                  </div>
                </div>
              </div>
            );
          }
          case "FSHYB":
            {
              return (
                <div className="row" style={diagramFontSize}>
                  <div className="col">
                    <div className="text-center text-white  mobilelivediagramcards">
                      <div className="card-body ">
                        <table align="center">
                          <tbody>
                            <tr>
                              <td colSpan="2"></td>
                              <td colSpan="1">
                                <hr className="vr" />
                              </td>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  Genset Status: {state.gstatus}
                                  {state.gAlarm !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#cc3300" }}>
                                        {state.gAlarm}
                                      </span>
                                    </>
                                  )}
                                  {state.gWarning !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#ffcc00" }}>
                                        {state.gWarning}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td colSpan="3"></td>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("grunning")}
                                    title="Genset Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("gonload")}
                                    title="Genset Onload Led"
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSgeneratorcell"
                                    src={generatorImg}
                                    title="Generator"
                                    id="generatorcell"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.GPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr></tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2">
                                <div>
                                  <figure>
                                    <img
                                      className="FSloadcell"
                                      src={homeImg}
                                      title="Load"
                                      style={{ height: "", width: "" }}
                                      id="loadcell"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load + "kW"}
                                      </strong>
                                      <br />
                                      <strong>Consumption</strong>
                                    </figcaption>
                                  </figure>
                                </div>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={inverterImg}
                                    style={{ height: "", width: "" }}
                                    title="Power Inverter"
                                    id="inverter"
                                  />
                                  <figcaption>
                                    <strong>&nbsp; &nbsp;</strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={pvImg}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="pv"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.PV + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Solar Panels</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSbatterycell"
                                    src={getBatteryImage(
                                      state.BatCapacity,
                                      state.BatCurrent,
                                      state.BatWarning
                                    )}
                                    style={{ height: "", width: "" }}
                                    id="battery"
                                    title="Battery"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.BatCurrent > 0
                                          ? "greentext"
                                          : "mobilebluetext"
                                      }
                                    >
                                      {state.BatCurrent + "kW"}
                                      <br />
                                      {"[" + state.BatCapacity + "% full]"}
                                    </strong>
                                    <br />
                                    <strong>Battery</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <strong>
                                  {state.HybWarningStatus !== "" && (
                                    <>
                                      Inverter Status: {state.HybWarningStatus}
                                      <br />
                                    </>
                                  )}
                                </strong>
                                <strong>
                                  {state.HybFault != ""
                                    ? "Inverter Fault: " + state.HybFault
                                    : ""}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div></div>
                        {state.MinSoC != undefined &&
                          state.MinSoC != "" &&
                          state.BatCap != undefined &&
                          state.BatCap != "" &&
                          state.BatCapacity != 100 &&
                          state.BatCurrent != 0 && (
                            <strong
                              className={
                                state.BatCurrent > 0
                                  ? "greentext"
                                  : "mobilebluetext"
                              }
                            >
                              {calculateChargingOrDischargingTime()}
                            </strong>
                          )}
                      </div>
                      <strong>-{" " + params.siteid + " "}-</strong>
                    </div>
                  </div>
                </div>
              );
            }
            break;
          case "FSOG":
            {
              //fuel save on grid inverter
              return (
                <div className="row" style={diagramFontSize}>
                  <div className="col">
                    <div className="text-center text-white  mobilelivediagramcards">
                      <div className="card-body ">
                        <table align="center">
                          <tbody>
                            <tr>
                              <td colSpan="2"></td>
                              <td colSpan="1">
                                <hr className="vr" />
                              </td>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  Genset Status: {state.gstatus}
                                  {state.gAlarm !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#cc3300" }}>
                                        {state.gAlarm}
                                      </span>
                                    </>
                                  )}
                                  {state.gWarning !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#ffcc00" }}>
                                        {state.gWarning}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td colSpan="3"></td>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("grunning")}
                                    title="Genset Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("gonload")}
                                    title="Genset Onload Led"
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSgeneratorcell"
                                    src={generatorImg}
                                    title="Generator"
                                    id="generatorcell"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.GPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr></tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2">
                                <div>
                                  <figure>
                                    <img
                                      className="FSloadcell"
                                      src={homeImg}
                                      title="Load"
                                      style={{ height: "", width: "" }}
                                      id="loadcell"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load + "kW"}
                                      </strong>
                                      <br />
                                      <strong>Consumption</strong>
                                    </figcaption>
                                  </figure>
                                </div>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={onGridInverterImg}
                                    style={{ height: "", width: "" }}
                                    title="Power Inverter"
                                    id="inverter"
                                  />
                                  <figcaption>
                                    <strong>
                                      {state.OGIPowerSet != undefined
                                        ? "S" + state.OGIPowerSet + "kW"
                                        : ""}
                                    </strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={pvImg}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="pv"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.PV + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Solar Panels</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div></div>
                        {state.MinSoC != undefined &&
                          state.MinSoC != "" &&
                          state.BatCap != undefined &&
                          state.BatCap != "" &&
                          state.BatCapacity != 100 &&
                          state.BatCurrent != 0 && (
                            <strong
                              className={
                                state.BatCurrent > 0
                                  ? "greentext"
                                  : "mobilebluetext"
                              }
                            >
                              {calculateChargingOrDischargingTime()}
                            </strong>
                          )}
                      </div>
                      <strong>-{" " + params.siteid + " "}-</strong>
                    </div>
                  </div>
                </div>
              );
            }
            break;
          case "FSCOMPHYB":
            {
              // fuel save with ongrid and hybride inverter
              return (
                <div className="row" style={diagramFontSize}>
                  <div className="col">
                    <div className="text-center text-white  mobilelivediagramcards">
                      <div className="card-body ">
                        <table align="center">
                          <tbody>
                            <tr>
                              <td colSpan="2"></td>
                              <td colSpan="1">
                                <hr className="vr" />
                              </td>
                              <td colSpan="2">
                                <p
                                  className="card-text font-weight-bold"
                                  align="center"
                                >
                                  Genset Status: {state.gstatus}
                                  {state.gAlarm !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#cc3300" }}>
                                        {state.gAlarm}
                                      </span>
                                    </>
                                  )}
                                  {state.gWarning !== "" && (
                                    <>
                                      <br />
                                      <span style={{ color: "#ffcc00" }}>
                                        {state.gWarning}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td colSpan="3"></td>
                              <td>
                                <div>
                                  <img
                                    className="ledimage"
                                    src={displayled("grunning")}
                                    title="Genset Running Led"
                                  />
                                  <label>
                                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                  </label>
                                  <img
                                    className="ledimage"
                                    src={displayled("gonload")}
                                    title="Genset Onload Led"
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSgeneratorcell"
                                    src={generatorImg}
                                    title="Generator"
                                    id="generatorcell"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.GPower + "kW"}
                                    </strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="3"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={onGridInverterImg}
                                    style={{ height: "", width: "" }}
                                    title="Power Ongrid Inverter"
                                    id="ongridinverter"
                                  />
                                  <figcaption>
                                    <strong>
                                      {state.OGIPowerSet != undefined
                                        ? "S" + state.OGIPowerSet + "kW"
                                        : ""}
                                    </strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={pvImg}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="gridpv"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.gridPV + "kW"}
                                    </strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2">
                                <div>
                                  <figure>
                                    <img
                                      className="FSloadcell"
                                      src={homeImg}
                                      title="Load"
                                      style={{ height: "", width: "" }}
                                      id="loadcell"
                                    />
                                    <figcaption>
                                      <strong className="greentext">
                                        {state.Load + "kW"}
                                      </strong>
                                      <br />
                                      <strong>Consumption</strong>
                                    </figcaption>
                                  </figure>
                                </div>
                              </td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSinvertercell"
                                    src={inverterImg}
                                    style={{ height: "", width: "" }}
                                    title="Power Inverter"
                                    id="inverter"
                                  />
                                  <figcaption>
                                    <strong>&nbsp; &nbsp;</strong>
                                    <br />
                                    <strong>&nbsp; &nbsp;</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <figure>
                                  <img
                                    className="FSpvcell"
                                    src={pvImg}
                                    style={{ height: "", width: "" }}
                                    title="Solar Panels"
                                    id="pv"
                                  />
                                  <figcaption>
                                    <strong className="mobilebluetext">
                                      {state.PV + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Solar Panels</strong>
                                  </figcaption>
                                </figure>
                              </td>
                            </tr>
                            <tr>
                              <td className="tr_inmode_table" colSpan="2"></td>
                              <td className="tr_inmode_table">
                                <figure>
                                  <img
                                    className="FSbatterycell"
                                    src={getBatteryImage(
                                      state.BatCapacity,
                                      state.BatCurrent,
                                      state.BatWarning
                                    )}
                                    style={{ height: "", width: "" }}
                                    id="battery"
                                    title="Battery"
                                  />
                                  <figcaption>
                                    <strong
                                      className={
                                        state.BatCurrent > 0
                                          ? "greentext"
                                          : "mobilebluetext"
                                      }
                                    >
                                      {state.BatCurrent + "kW"}
                                      <br />
                                      {"[" + state.BatCapacity + "% full]"}
                                    </strong>
                                    <br />
                                    <strong>Battery</strong>
                                  </figcaption>
                                </figure>
                              </td>
                              <td className="tr_inmode_table" colSpan="2">
                                <strong>
                                  {state.HybWarningStatus !== "" && (
                                    <>
                                      Inverter Status: {state.HybWarningStatus}
                                      <br />
                                    </>
                                  )}
                                </strong>
                                <strong>
                                  {state.HybFault != ""
                                    ? "Inverter Fault: " + state.HybFault
                                    : ""}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div></div>
                        {state.MinSoC != undefined &&
                          state.MinSoC != "" &&
                          state.BatCap != undefined &&
                          state.BatCap != "" &&
                          state.BatCapacity != 100 &&
                          state.BatCurrent != 0 && (
                            <strong
                              className={
                                state.BatCurrent > 0
                                  ? "greentext"
                                  : "mobilebluetext"
                              }
                            >
                              {calculateChargingOrDischargingTime()}
                            </strong>
                          )}
                      </div>
                      <strong>-{" " + params.siteid + " "}-</strong>
                      <br />
                    </div>
                  </div>
                </div>
              );
            }
            break;
          case "ACGSTD": //standard AC Generator
          default: {
            return (
              <div className="row">
                <div className="col">
                  <div className="text-center text-white  mobilelivediagramcards">
                    <div className="card-body ">
                      <table align="center">
                        <tbody>
                          <tr>
                            <td colSpan="3">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                Genset Status: {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table">
                              <img
                                className="loadcell"
                                src={loadImg}
                                title="Load"
                              />
                            </td>
                            <td className="tr_inmode_table">
                              <img
                                src={
                                  state.gonload ? contactorClose : contactorOpen
                                }
                                className="contClose"
                                title="Contactor"
                              />
                            </td>
                            <td className="tr_inmode_table">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                              <img
                                className="generatorcell"
                                src={state.grunning ? g1OnImg : g1offImg}
                                title="Generator"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                      {state.MinSoC != undefined &&
                        state.MinSoC != "" &&
                        state.BatCap != undefined &&
                        state.BatCap != "" &&
                        state.BatCapacity != 100 &&
                        state.BatCurrent != 0 && (
                          <strong
                            className={
                              state.BatCurrent > 0
                                ? "greentext"
                                : "mobilebluetext"
                            }
                          >
                            {calculateChargingOrDischargingTime()}
                          </strong>
                        )}
                    </div>
                    <strong>-{" " + params.siteid + " "}-</strong>
                  </div>
                </div>
              </div>
            );
          }
        }
      }
    }
  } else {
    //offline display
    return (
      <div className="container">
        <div className="col text-white">
          <div>
            <center>
              <img src={offlineImg} className="simpleloadingview" />
              <p>
                <strong>
                  The site appears to be offline, try to refresh the page in 5
                  minutes.
                </strong>
              </p>
            </center>
          </div>
        </div>
      </div>
    );
  }
};
export default Mobiledisplay;
